import React, { useState, useEffect, useRef } from 'react';
import { Image, Form, Button } from 'react-bootstrap';
import RangeSlider from 'react-range-slider-input';
import "../../styles/Employees/filterField.scss";

type HandleData = (val: RangeValue) => void

export interface FilterOption {
    filterValue: string,
    isSelect: boolean,
    value?: string;
}

export type RangeValue = [number, number];


interface PropsObject {
    filterBy: string,
    filterTitle: string,
    filterOptions?: FilterOption[],
    filterType: string,
    rangeValue?: RangeValue,
    handleData?: HandleData
    onApply?: (data: FilterOption[]) => void;
}

const FilterComponent: React.FC<PropsObject> = (props) => {


    const [isDropOpen, setIsDropOpen] = useState<boolean>(false);
    const [localOptions, setLocalOptions] = useState<FilterOption[]>([]);
    const [localRange, setLocalRange] = useState<RangeValue | undefined>();
    const [appliedRange, setAppliedRange] = useState<RangeValue | undefined>();
    const [appliedOptions, setAppliedOptions] = useState<FilterOption[]>([]);

    const { filterBy, filterTitle, filterOptions, filterType, rangeValue, handleData, onApply } = props;
    const targetRef = useRef<HTMLDivElement | null>(null);


    useEffect(() => {
        const handleDropClose = (e: MouseEvent) => {
            if (
                targetRef.current &&
                e.target instanceof Node &&
                !targetRef.current.contains(e.target)
            ) {
                setIsDropOpen(false);
            }
        }

        window.addEventListener('click', handleDropClose)

        return () => {
            window.removeEventListener('click', handleDropClose);
        }
    }, [])


    useEffect(() => {
        if (!isDropOpen) return;

        if (filterType === "checkbox") {
            setLocalOptions(filterOptions ?? []);
        }

        if (filterType === "range") {
            setLocalRange(rangeValue ?? [0, 100]);
        }
    }, [
        isDropOpen,
        filterType,
        // appliedOptions,
        // appliedRange,
        filterOptions,
        rangeValue
    ]);
    useEffect(() => {
        if (filterType !== "checkbox") return;

        const hasAnySelected = filterOptions?.some(o => o.isSelect);

        if (!hasAnySelected) {
            setAppliedOptions([]);
            setLocalOptions(filterOptions ?? []);
        }
    }, [filterOptions, filterType]);


    useEffect(() => {
        if (filterType !== "range" || !rangeValue?.length) return;

        setAppliedRange(rangeValue);
        setLocalRange(rangeValue);
    }, [rangeValue, filterType]);

    const handleCheckboxChange = (index: number) => {
        setLocalOptions(prev =>
            prev.map((item, i) =>
                i === index
                    ? { ...item, isSelect: !item.isSelect }
                    : item
            )
        );
    };

    const handleReset = () => {
        if (filterType === "checkbox") {
            const cleared = localOptions.map(o => ({ ...o, isSelect: false }));
            setLocalOptions(cleared);
            setAppliedOptions([]);
            // onApply?.(cleared);
        }

        if (filterType === "range") {
            const cleared: RangeValue = [0, 100];
            setLocalRange(cleared);
            setAppliedRange([0, 100]);
            // handleData?.(cleared);
        }
    };

    const handleApply = () => {

        if (filterType === "checkbox") {
            setAppliedOptions(localOptions);
            onApply?.(localOptions);
        }

        if (filterType === "range" && localRange) {
            setAppliedRange(localRange);
            handleData?.(localRange);
        }
        setIsDropOpen(false);
    };

    const appliedCount = filterOptions?.filter(o => o.isSelect).length;
    const showAppliedRange =
        filterType === "range" &&
        rangeValue &&
        !(rangeValue[0] === 0 && rangeValue[1] === 100);


    return (
        <div className='filter-field' ref={targetRef}>
            <h6>{filterBy} :</h6>
            <div className='filter-count-cont' onClick={() => setIsDropOpen(!isDropOpen)}>
                {filterType === "checkbox" && appliedCount !== 0 && (
                    <div className="fltr-count">
                        <p>{appliedCount}</p>
                    </div>
                )}

                {filterType === "range" && showAppliedRange && (
                    <div className="fltr-count range">
                        <p>{rangeValue![0]}% - {rangeValue![1]}%</p>
                    </div>
                )}

                <h6 className="applied">
                    {filterType === "checkbox"
                        ? appliedCount !== 0
                            ? "Applied"
                            : filterTitle
                        : showAppliedRange
                            ? "Applied"
                            : filterTitle}
                </h6>

                <Image src='/images/employees/filter_arrow.svg' alt='Arrow'
                    className={`${isDropOpen ? "rotate_arrow" : "rotate_arrow_back"}`}
                />
            </div>
            <div className={`fltr-drp-down ${isDropOpen ? '' : 'd-none'}`}>
                {filterType === 'checkbox' ?
                    <div className='flter-vls-cont'>
                        {localOptions.length > 0 ? localOptions.map((res, i) => (
                            <Form.Check
                                id={`checkbox-${i}-${res.filterValue}`}
                                key={`${res.filterValue}-${i}`}
                                inline
                                label={res.filterValue}
                                type="checkbox"
                                className="chk-box"
                                checked={res.isSelect}
                                onChange={() => handleCheckboxChange(i)}
                            />
                        )) : <span className='no-options-found'>No Data Found</span>}
                    </div> :
                    <div className='slider-cont'>
                        <RangeSlider
                            className="dual-slide"
                            value={localRange}
                            onInput={(val) => setLocalRange(val)}
                        />
                        <div className="range-val">
                            <h6>{localRange?.[0]}%</h6>
                            <h6>{localRange?.[1]}%</h6>
                        </div>
                    </div>
                }
                {(filterOptions?.length && filterType === "checkbox") || filterType === "range" ? <div className='fltr-btn'>
                    <Button
                        className="reset-btn"
                        variant="outline-secondary"
                        onClick={handleReset}
                    >
                        Reset
                    </Button>
                    <Button
                        className="apply-btn"
                        onClick={handleApply}
                    >
                        Apply
                    </Button>
                </div> : <></>}
            </div>
        </div>
    );
};

export default FilterComponent;